import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthUserData } from 'hooks';
import { IconButton } from '@totalsoft/rocket-ui';
import AddIcon from '@mui/icons-material/Add';
import { InsuranceListHeaderLinksWrapper } from './InsuranceDocumentListStyles';

function InsuranceDocumentListHeaderLinks() {
  const { t } = useTranslation();
  const history = useHistory();
  const { authUser } = useAuthUserData();

  const onAddNew = useCallback(() => {
    history.push('/insurance-documents/new');
  }, [history]);

  return (
    <InsuranceListHeaderLinksWrapper>
      {authUser?.authorizations?.hasRightToAddOffer && (
        <IconButton id='insuranceOffer_AddNewOffer' color='primary' variant='text' onClick={onAddNew} tooltip={t('Tooltips.AddNewOffer')}>
          <AddIcon />
        </IconButton>
      )}
    </InsuranceListHeaderLinksWrapper>
  );
}

export default InsuranceDocumentListHeaderLinks;
